import {Radio, Checkbox, FgInput, Button, Dropdown, Card} from 'src/components/UIComponents';
import SmoothScrollbar from 'vue-smooth-scrollbar'

import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style
import 'swiper/dist/css/swiper.css'


/**
 * You can register global components here and use them as a plugin in your main Vue instance
 * Ideally, only small components that are re-used many times across your application should be registered here.
 * For plugins and bigger components local registration is preferable because it will allow you to do code splitting easier :)
 */

const GlobalComponents = {
  install (Vue) {
    Vue.component(FgInput.name, FgInput)
    Vue.component(Dropdown.name, Dropdown)
    Vue.component(Checkbox.name, Checkbox)
    Vue.component(Radio.name, Radio)
    Vue.component(Button.name, Button)
    Vue.component(Card.name, Card)
    Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
    // Vue.use(SmoothScrollbar)    
  }
}

export default GlobalComponents
